'use client';
import styled from 'styled-components';
import { colors } from '@/styles';
import { TEntryDataType } from '@/types';

export const Badge = styled.span<{ $variant?: TEntryDataType; $small: boolean }>`
  padding: ${(props) => (props.$small ? '2px 5px' : '5px 10px')};
  border-radius: 5px;
  border: none;
  font-size: 12px;
  color: ${colors.primary.black};
  background-color: ${colors.secondary.lightGray2};
  background-color: ${(props) => props.$variant && colors.data[props.$variant as TEntryDataType].light};
  display: inline-flex;
  align-items: center !important;
  gap: 5px;
  & > span {
    overflow: hidden;
    text-overflow: ellipsis;
  }
  & > svg {
    min-width: 16px;
  }
`;
